@use 'themes/westfield' as *;
// Common form styles
// ==================

@use 'tools/dirg' as *;

.Form {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;

  > * + * {
    margin-top: units(1);
  }
}
